import { render, staticRenderFns } from "./PostDeclaredContent.vue?vue&type=template&id=19704407"
import script from "./PostDeclaredContent.vue?vue&type=script&lang=js"
export * from "./PostDeclaredContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports